// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/BusinessLocationService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { BusinessLocationDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { BusinessLocationCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { BusinessLocationDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { BusinessLocationFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/BusinessLocationService.proto.
 */
export const file_Services_BusinessLocationService: GenFile = /*@__PURE__*/
  fileDesc("CiZTZXJ2aWNlcy9CdXNpbmVzc0xvY2F0aW9uU2VydmljZS5wcm90bzLnCQoXQnVzaW5lc3NMb2NhdGlvblNlcnZpY2USlAIKE0dldEJ1c2luZXNzTG9jYXRpb24SPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjwudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0xvY2F0aW9uRGV0YWlsZWREdG8if6DazQ8AgtPkkwJ0Wi46ASoiKS9hcGkvYnVzaW5lc3NMb2NhdGlvbi9nZXRCdXNpbmVzc0xvY2F0aW9uEkIvYXBpL2J1c2luZXNzTG9jYXRpb24vZ2V0QnVzaW5lc3NMb2NhdGlvbi97aWQuaGlnaF82NH0ve2lkLmxvd182NH0S0QEKFEdldEJ1c2luZXNzTG9jYXRpb25zEjoudGltZV90cmFja2luZy5tZXNzYWdlcy5maWx0ZXJzLkJ1c2luZXNzTG9jYXRpb25GaWx0ZXJzRHRvGkEudGltZV90cmFja2luZy5tZXNzYWdlcy5jb2xsZWN0aW9ucy5CdXNpbmVzc0xvY2F0aW9uQ29sbGVjdGlvbkR0byI6oNrNDwCC0+STAi86ASoiKi9hcGkvYnVzaW5lc3NMb2NhdGlvbi9nZXRCdXNpbmVzc0xvY2F0aW9ucxLHAQoWQ3JlYXRlQnVzaW5lc3NMb2NhdGlvbhIxLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuQnVzaW5lc3NMb2NhdGlvbkR0bxo8LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuQnVzaW5lc3NMb2NhdGlvbkRldGFpbGVkRHRvIjyg2s0PAILT5JMCMToBKiIsL2FwaS9idXNpbmVzc0xvY2F0aW9uL2NyZWF0ZUJ1c2luZXNzTG9jYXRpb24SlAIKFlVwZGF0ZUJ1c2luZXNzTG9jYXRpb24SMS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLkJ1c2luZXNzTG9jYXRpb25EdG8aPC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLkJ1c2luZXNzTG9jYXRpb25EZXRhaWxlZER0byKIAaDazQ8AgtPkkwJ9OgEqWjE6ASoiLC9hcGkvYnVzaW5lc3NMb2NhdGlvbi91cGRhdGVCdXNpbmVzc0xvY2F0aW9uGkUvYXBpL2J1c2luZXNzTG9jYXRpb24vdXBkYXRlQnVzaW5lc3NMb2NhdGlvbi97aWQuaGlnaF82NH0ve2lkLmxvd182NH0S/wEKFkRlbGV0ZUJ1c2luZXNzTG9jYXRpb24SJi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkRHRvGjwudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0xvY2F0aW9uRGV0YWlsZWREdG8if6DazQ8AgtPkkwJ0WjE6ASoiLC9hcGkvYnVzaW5lc3NMb2NhdGlvbi9kZWxldGVCdXNpbmVzc0xvY2F0aW9uKj8vYXBpL2J1c2luZXNzTG9jYXRpb24vZGVsZXRlQnVzaW5lc3NMb2NhdGlvbi97aGlnaF82NH0ve2xvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for business locations.
 *
 * @generated from service BusinessLocationService
 */
export const BusinessLocationService: GenService<{
  /**
   * Fetch a business location specified by its id.
   *
   * @generated from rpc BusinessLocationService.GetBusinessLocation
   */
  getBusinessLocation: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof BusinessLocationDetailedDtoSchema;
  },
  /**
   * Fetch business locations according to filters.
   *
   * @generated from rpc BusinessLocationService.GetBusinessLocations
   */
  getBusinessLocations: {
    methodKind: "unary";
    input: typeof BusinessLocationFiltersDtoSchema;
    output: typeof BusinessLocationCollectionDtoSchema;
  },
  /**
   * Create a new business location.
   *
   * @generated from rpc BusinessLocationService.CreateBusinessLocation
   */
  createBusinessLocation: {
    methodKind: "unary";
    input: typeof BusinessLocationDtoSchema;
    output: typeof BusinessLocationDetailedDtoSchema;
  },
  /**
   * Modify business location properties.
   *
   * @generated from rpc BusinessLocationService.UpdateBusinessLocation
   */
  updateBusinessLocation: {
    methodKind: "unary";
    input: typeof BusinessLocationDtoSchema;
    output: typeof BusinessLocationDetailedDtoSchema;
  },
  /**
   * Delete the business location with the given id.
   *
   * @generated from rpc BusinessLocationService.DeleteBusinessLocation
   */
  deleteBusinessLocation: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof BusinessLocationDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_BusinessLocationService, 0);

